import { createAsyncThunk } from "@reduxjs/toolkit";
import { getData } from "../../../../services/apiEndpoints";
import { handleError } from "../../Common/Alerts/errorhandling.action";

export const fetchIncomeStatementThunk = createAsyncThunk(
  "financialStatements/fetchIncomeStatement",
  async (filter = "thisMonth", { rejectWithValue }) => {
    try {
      const response = await getData(
        `/finance/statements/getIncomeStatement?filter=${filter}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch income statement"
      );
    }
  }
);

export const fetchBalanceSheetThunk = createAsyncThunk(
  "financialStatements/fetchBalanceSheet",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await getData(`/finance/statements/getBalanceSheet`);
      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);
